import React from "react";
import { useAuthStore } from "../../store/AuthStore";
import Loader from "../mini/Loader";
import { useHistory } from "react-router-dom";
import Tag from "../mini/Tag";
import { useQuery } from "@tanstack/react-query";
import { getBlogTagsAPI } from "../../api/GetTags";
import * as H from "./Home.styled";

const FollowedTags = () => {
  const history = useHistory();
  const { isLoggedIn, mainBlogId, blogData } = useAuthStore();

  const { isLoading, data: tags } = useQuery({
    queryKey: ["GetFollowedTags"],
    queryFn: () =>
      getBlogTagsAPI({
        size: 4,
        page: 1,
        type: "keyword",
        category: isLoggedIn ? "following" : "popular",
      }),
    select: ({ data }) => data.data.tags,
  });

  const handleSearchTag = (tag) => {
    history.push(`/search/1/posts/${tag.name}/${tag.id}`);
  };

  const handleViewAllTags = () => {
    history.push({
      pathname: mainBlogId
        ? `/dashboard/${blogData.urlSlug}/tags_i_follow`
        : "/user/dashboard",
      state: { key: mainBlogId ? "tags_i_follow" : "bookmarked" },
    });
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        tags &&
        tags.length > 0 && (
          <H.HomeSidebarWrapper>
            <H.HomeTitle>
              {isLoggedIn ? "Tags I Follow" : "Popular Tags"}
            </H.HomeTitle>
            {tags.map((tag, i) => (
              <div
                key={i}
                style={{ cursor: "pointer" }}
                onClick={() => handleSearchTag(tag)}
              >
                <Tag tagName={tag.name} count={tag.usedCount} />
              </div>
            ))}
            {isLoggedIn && (
              <H.ViewAll onClick={handleViewAllTags}>View All</H.ViewAll>
            )}
          </H.HomeSidebarWrapper>
        )
      )}
    </>
  );
};

export default FollowedTags;
